<template>
  <div class="servers">
    <el-button size="small" @click="fetch">
      <i class="fa fa-refresh" aria-hidden="true"></i>
    </el-button>
    <el-tabs v-if="isFetched" :value="selectedServerId" @tab-click="handleClick">
      <el-tab-pane v-for="name in serverIds" :label="name" :name="name" :key="name">
        <server :server-id="name"></server>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<style lang="scss" scoped>
  .servers {
    padding: 20px;

    button {
      position: absolute;
      right: 20px;
      z-index: 1;
    }
  }
</style>


<script>
import { mapActions, mapState } from 'vuex'
import Server from './Server'

export default {

  components: {
    Server
  },

  mounted () {
    if (!this.isFetched) {
      this.fetch()
    }
  },

  computed: {
    ...mapState('servers', {
      isFetching: state => state.isFetching,
      servers: state => state.entities,
      isFetched: state => state.ids.length !== 0,
      serverIds: state => state.ids,
      selectedServerId: state => state.selectedEntityId
    })
  },

  methods: {
    handleClick (tab) {
      this.select(tab.name)
    },
    ...mapActions('servers', ['fetch', 'select'])
  }
}
</script>




// WEBPACK FOOTER //
// src/components/servers/Servers.vue